import { FactuurObject } from 'src/app/shared/model/factuur';
import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-factuur-nav',
  templateUrl: './factuur-nav.component.html',
  styleUrls: ['./factuur-nav.component.less']
})
export class FactuurNavComponent implements OnInit {


  @Input() list: Array<FactuurObject> =[];
  @Input() record: number = null;
  @Output() objectChanged =  new EventEmitter<any>();
  current = 1;
  routeid = 0;


  constructor( private activatedRoute: ActivatedRoute) {  }

  ngOnInit(): void {
    this.routeid = Number(this.activatedRoute.snapshot.paramMap.get('id'));
  }



  prev() {
    if (this.current != 1) this.current--;
    this.emit();
  }

  next() {
    if (this.current < this.list.length) this.current++;
    this.emit();
  }

  emit() {
    this.objectChanged.emit({ID:this.list[this.current-1].ID, record: this.current});
  }


  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);
    if (changes["list"]) {
      if (this.routeid) {
        for(let i =0; i < this.list.length;i++) {
            if (this.list[i].FactuurNummer === this.routeid) {
              this.current = i+1;
              this.emit();
              break;
            }
        }
      }
    }
    if (changes["record"]) {
      if (this.current != changes["record"].currentValue) {
        this.current = changes["record"].currentValue
      }
      return;
    }
    if (!this.routeid) this.current = 1;
  }


}
